

<body>
  <div class="container mt-5">
    <h2 class="text-center mb-4">Informations générales</h2>
    
    <!-- Profile Card -->
    <div class="row justify-content-center" *ngIf="user">
      <div class="col-md-8">
        <mat-card class="shadow-sm p-4">
          <!-- Profile Image Section -->
          <div class="d-flex align-items-center mb-4">
            <div class="profile-avatar">
              <img *ngIf="civilite == 'Monsieur'" src="../../assets/img_avatar.png" alt="Avatar Homme" class="rounded-circle" style="width:80px; height:80px;">
              <img *ngIf="civilite == 'Madame'" src="../../assets/img_avatar2.png" alt="Avatar Femme" class="rounded-circle" style="width:80px; height:80px;">
              <img *ngIf="civilite != 'Madame' && civilite != 'Monsieur'" src="https://mdbcdn.b-cdn.net/img/new/avatars/1.webp" alt="Default Avatar" class="rounded-circle" style="width:80px; height:80px;">
            </div>
            <div class="ms-3">
              <h3>{{ user.firstname }} {{ user.lastname }}</h3>
              <p class="text-muted">{{ user.role | titlecase }}</p>
            </div>
          </div>
          
          <!-- User Details Section -->
          <mat-divider></mat-divider>
          <div class="row mt-3">
            <div class="col-sm-6 mb-3">
              <strong>Type utilisateur:</strong> 
              <span *ngIf="user.role == 'superadmin'">AdminSMT</span>
              <span *ngIf="user.role == 'adminbanque'">Admin Banque</span>
              <span *ngIf="user.usertype == 'Metier' && user.role == 'userbanque'">Métier</span>
              <span *ngIf="user.usertype == 'Agence'">Agence Banque</span>
              <span *ngIf="user.usertype == 'comite arbitrage'">Comité Arbitrage</span>
              <span *ngIf="user.usertype == 'Clientpor'">Client Porteur</span>
              <span *ngIf="user.usertype == 'Clientcomm'">Client Commerçant</span>
            </div>
            <div class="col-sm-6 mb-3">
              <strong>Créé le (GMT):</strong> {{ user.created | customDate }}
            </div>
            <div class="col-sm-6 mb-3">
              <strong>Dernière modification (GMT):</strong> {{ user.updated | customDate }}
            </div>
            <div class="col-sm-6 mb-3">
              <strong>Login:</strong> {{ user.contact || user.email }}
            </div>
            <div class="col-sm-6 mb-3">
              <strong>Numéro mobile:</strong> {{ user.mobile }}
            </div>
            <div class="col-sm-6 mb-3" *ngIf="user.usertype != 'Clientpor' && user.usertype != 'Clientcomm' && user.role != 'superadmin'">
              <strong>Code banque:</strong> {{ user.banque }}
            </div>
            <div class="col-sm-6 mb-3" *ngIf="user.usertype == 'Agence'">
              <strong>Indicatif agence:</strong> {{ user.indicatifagence }}
            </div>
            <div class="col-sm-6 mb-3" *ngIf="user.usertype == 'Clientpor'">
              <strong>Numéro de compte:</strong> {{ user.compte }}
            </div>
            <div class="col-sm-6 mb-3" *ngIf="user.usertype == 'Clientpor'">
              <strong>Numéro de carte:</strong> {{ user.carte }}
            </div>
            <div class="col-sm-6 mb-3" *ngIf="user.usertype == 'Clientcomm'">
              <strong>Numéro d'affiliation:</strong> {{ user.affiliation }}
            </div>
            <div class="col-sm-6 mb-3" *ngIf="user.usertype == 'Clientcomm'">
              <strong>Numéro de terminal:</strong> {{ user.terminal }}
            </div>
          </div>
          
          <!-- Action Button -->
          <div class="text-center mt-4">
            <button mat-raised-button color="primary" (click)="getNavigation('auth/modify-user', currentUser.userId)">Modifier</button>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</body>
